import { mdCanReadModule, type AppModule } from '@stores/modulePermissions';

export type DashboardTab = 'general' | 'sales' | 'warehouse' | 'service';

export interface DashboardTabDefinition {
  value: DashboardTab;
  label: string;
  /** Модуль, який ModuleAuthorizationMiddleware вимагає для /api/analytics/{...}-dashboard */
  module: AppModule;
}

// Порядок = порядок сегментів; перший дозволений відкривається за замовчуванням
export const MD_DASHBOARD_TABS: readonly DashboardTabDefinition[] = [
  { value: 'general', label: 'Загальний', module: 'Admin' },
  { value: 'sales', label: 'Продажі', module: 'Sales' },
  { value: 'warehouse', label: 'Склад', module: 'WMS' },
  { value: 'service', label: 'Сервіс', module: 'ServiceRequests' },
];

/** Дашборди, які сервер дозволить ролям хоча б читати */
export function mdGetAllowedDashboardTabs(mdRoles: readonly string[]): DashboardTabDefinition[] {
  return MD_DASHBOARD_TABS.filter((mdTab) => mdCanReadModule(mdRoles, mdTab.module));
}
